"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastAutoCompoundTime = getLastAutoCompoundTime;
const fetchAutoCompoundingEvents_js_1 = require("./sui-sdk/events/fetchAutoCompoundingEvents.js");
async function getLastAutoCompoundTime(poolName) {
    const endTime = Date.now();
    const startTime = endTime - 3 * 60 * 60 * 1000; // timestamp for 3 hours ago
    const events = await (0, fetchAutoCompoundingEvents_js_1.fetchAutoCompoundingEvents)({
        startTime: startTime,
        endTime: endTime,
        poolNames: [poolName],
    });
    if (events.length > 0)
        return events[0].timestamp.toString();
    return startTime.toString();
}
//# sourceMappingURL=getLastAutoCompoundTime.js.map